import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js/min';

// Thin shims on top of libphonenumber-js so the rest of the codebase
// doesn't import the library directly. Using the /min bundle — smaller
// metadata, no regex-mobile-pattern validation — which is plenty for
// signup/destination shape checks.

/**
 * True when `value` is a full, valid E.164 phone number. Rejects
 * empty strings, values missing the leading `+`, and numbers that
 * parse as country-impossible / wrong-length. Silent on failure —
 * callers render their own message.
 */
export function isValidE164(value: string | null | undefined): boolean {
  if (!value) return false;
  if (!value.startsWith('+')) return false;
  try {
    return isValidPhoneNumber(value);
  } catch {
    return false;
  }
}

/**
 * Normalise a possibly-spaced / separator-ed E.164 string to the
 * canonical digit-only form ("+34 612 345 678" → "+34612345678").
 * Returns the original string unchanged when parsing fails — the
 * caller is then free to reject it via isValidE164.
 */
export function normaliseE164(value: string): string {
  if (!value) return value;
  try {
    const parsed = parsePhoneNumberFromString(value);
    if (parsed && parsed.isValid()) return parsed.number;
  } catch {
    /* fall through */
  }
  return value;
}
